var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfoNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
    fill: "#003E36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9995 16C22.9995 15.1716 23.6711 14.5 24.4995 14.5H24.5175C25.3459 14.5 26.0175 15.1716 26.0175 16C26.0175 16.8284 25.3459 17.5 24.5175 17.5H24.4995C23.6711 17.5 22.9995 16.8284 22.9995 16ZM24.2971 20.55C24.7356 20.609 25.296 20.7606 25.7677 21.2322C26.2392 21.7038 26.391 22.2641 26.45 22.7029C26.5004 23.0773 26.5002 23.5209 26.5 23.9312C26.5 23.9542 26.5 23.9772 26.5 24.0001V32.0001C26.5 32.8285 25.8284 33.5001 25 33.5001C24.1716 33.5001 23.5 32.8285 23.5 32.0001V24.0001C23.5 23.8019 23.4999 23.6413 23.4977 23.5024C23.3588 23.5001 23.1982 23.5001 23 23.5001C22.1716 23.5001 21.5 22.8285 21.5 22.0001C21.5 21.1716 22.1716 20.5001 23 20.5001C23.0228 20.5001 23.0458 20.5001 23.0689 20.5C23.4791 20.4999 23.9227 20.4997 24.2971 20.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoNoti);
export default __webpack_public_path__ + "static/media/iconInfoNoti.8a4549e9f5044dfe85ce84bb9e233492.svg";
export { ForwardRef as ReactComponent };